<script setup lang="ts">
	interface NavigationSubItem {
		label: string,
		path: string,
		title: string,
	}
	interface NavigationItem {
		label: string,
		path: string,
		title: string,
		children: Array<NavigationSubItem>
	}

	export type {
		NavigationSubItem,
		NavigationItem
	}

	const $props = defineProps<{
		items: Array<NavigationItem>,
		footerItems?: Array<NavigationItem[]>,
	}>()
</script>

<template>
	<nav v-if="items && items.length" role="navigation">
		<ul class="divide-y divide-gray-200">
			<li v-for="(item,idx) in items.concat(footerItems)" :class="{ 'py-2.5 lg:py-4': item.name }">
				<NuxtLink v-if="item.name" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" class="font-medium text-[1rem] witespace-nowrap hover:text-yellow-sea-500 transition duration-300 ease-in-out" :title="item.title" no-prefetch>{{ item.label }}</NuxtLink>
				<NavigationSubMegaMobile v-else :item="item" :key="'sub-'+idx" />
			</li>
		</ul>
	</nav>
</template>
